// SaunaCloud promotional photography supplied by the partner. Presented as design inspiration —
// not as a record of completed customer installations, and not split into commercial/residential.
// Each entry has pre-generated 800px and 1600px WebP derivatives under /media/saunacloud/.
// Slot 10 of the supplied ZIP is omitted: its file is pixel-identical to 17, and the ZIP's own
// README states the real image 10 was not included. 17 unique photographs are shown.
export const SAUNACLOUD_GALLERY = [
  {
    base: "01-saunacloud-forest-view-glass-sauna",
    w: 1920,
    h: 1275,
    alt: "Glass-fronted sauna with cedar benches looking out over a forest",
  },
  {
    base: "02-saunacloud-wood-sauna-mountain-deck-view",
    w: 1920,
    h: 1275,
    alt: "Wood-lined sauna with a glass wall opening onto a mountain deck view",
  },
  {
    base: "03-saunacloud-two-women-sauna-wellness-hero",
    w: 1920,
    h: 1275,
    alt: "Two women seated on the cedar benches of a warmly illuminated sauna",
  },
  {
    base: "04-saunacloud-glass-sauna-and-shower",
    w: 1536,
    h: 2048,
    alt: "Glass sauna installed alongside a walk-in shower in a stone bathroom",
  },
  {
    base: "05-saunacloud-red-light-city-interior",
    w: 1920,
    h: 1275,
    alt: "Sauna interior with red light therapy panels and a city skyline view",
  },
  {
    base: "06-saunacloud-outdoor-mountain-sauna",
    w: 1920,
    h: 1275,
    alt: "Outdoor sauna cabin set against a mountain landscape",
  },
  {
    base: "07-saunacloud-modern-sauna-spa-bathroom",
    w: 1656,
    h: 946,
    alt: "Modern sauna built into a spa-style bathroom with warm wood detailing",
  },
  {
    base: "08-saunacloud-man-relaxing-wood-sauna",
    w: 1448,
    h: 1086,
    alt: "A man relaxing on the bench of a wood-lined sauna",
  },
  {
    base: "09-saunacloud-woman-relaxing-wood-sauna",
    w: 1536,
    h: 1024,
    alt: "A woman relaxing against the wall of a warmly lit wooden sauna",
  },
  {
    base: "11-saunacloud-shower-and-infrared-sauna",
    w: 1152,
    h: 2048,
    alt: "Infrared sauna paired with a glass shower enclosure",
  },
  {
    base: "12-saunacloud-red-light-wood-bench-interior",
    w: 960,
    h: 1280,
    alt: "Sauna interior with red light panels above a solid wood bench",
  },
  {
    base: "13-saunacloud-infrared-green-accent-light",
    w: 1152,
    h: 2048,
    alt: "Infrared sauna cabin lit with a green accent light",
  },
  {
    base: "14-saunacloud-window-view-sauna-benches",
    w: 1152,
    h: 2048,
    alt: "Sauna benches arranged beside a tall window",
  },
  {
    base: "15-saunacloud-red-light-glass-door",
    w: 960,
    h: 1280,
    alt: "Sauna with a full glass door and red light therapy inside",
  },
  {
    base: "16-saunacloud-custom-wood-bench-detail",
    w: 1536,
    h: 2048,
    alt: "Close detail of custom joinery on a sauna bench",
  },
  {
    base: "17-saunacloud-glass-sauna-stone-fireplace",
    w: 1872,
    h: 2048,
    alt: "Glass sauna in a living space with a stone fireplace",
  },
  {
    base: "18-saunacloud-red-light-sauna-bathroom-entry",
    w: 1536,
    h: 2048,
    alt: "Sauna entry with red interior lighting seen from a bathroom",
  },
];

export const SAUNACLOUD_URL = "https://saunacloud.com/?ref=5311eb6f30c2b97e";

export const galleryImage = (base, width) => `/media/saunacloud/${base}-${width}.webp`;
